precision lowp float;

uniform float time;
uniform float size;
uniform vec3 targetPosition;
uniform float radius;
uniform vec3 highlightColor;

varying float vDistanceToCamera;
varying vec4 color;


float sigmoidNormalization(float x, float k, float x0) {
    return 1.0 / (1.0 + exp(-k * (x - x0)));
}

void main() {

    float amplitude = .8;
    float waveAmplitude = .5;
    float frequencyY = 2.;
    float frequencyZ = 2.;
    float speed = 0.65;


    vec4 worldPosition = modelMatrix * vec4(position, 1.0); // Convert local position to world space
    vec4 viewPosition = viewMatrix * worldPosition; // Convert world position to view space

    // Create a spatial wave pattern based on the y and z world positions
    // Adjust the phase of the sine function to make neighbors move in opposite directions
    float spatialWave = sin(worldPosition.y * frequencyY + worldPosition.z * frequencyZ + time * speed) * waveAmplitude;

    gl_Position = projectionMatrix * viewPosition;

    vec4 cursorPosition = projectionMatrix * viewMatrix * vec4(position + targetPosition, 1.0);
    float vDistance = distance(vec4(gl_Position.xy, 1., 1.), vec4(cursorPosition.xy, 1., 1.));

    amplitude = smoothstep(.2, 8., vDistance);


    gl_Position.y += spatialWave * amplitude; // Apply the wave effect to the y-axis
    vDistanceToCamera = min(.5, sigmoidNormalization(gl_Position.y / gl_Position.w, 1.0, 0.8));
    color = vec4(0.8, 0.9, 0.98, vDistanceToCamera);
    if(vDistance <= radius) {
        color = vec4(highlightColor, vDistanceToCamera + 0.3);
        gl_Position.x += spatialWave * amplitude * 5. * (radius - vDistance);
        gl_Position.z += spatialWave * amplitude * 5. * (radius - vDistance);
        gl_Position.y += spatialWave * amplitude * 100. * (radius - vDistance); // Apply the wave effect to the y-axis
    }

    gl_PointSize = max(2., size * (spatialWave * 4.)); // Use the size uniform for the point size
}